import React, { useEffect } from 'react';
import { notification } from 'antd';
import { Button } from 'shared/components/Button';
import { useAppSelector } from 'shared/store';
import './style.less';

export const NewVersionBanner: React.FC = () => {
  const isNewVersionAvailable = useAppSelector(s => s.dashboard.isNewVersionAvailable);

  useEffect(() => {
    if (isNewVersionAvailable) {
      notification.open({
        key: 'NewVersionBanner',
        duration: 0,
        closeIcon: () => null,
        placement: 'bottomLeft',
        className: 'NewVersionBanner',
        message: 'Update available',
        description: (
          <div>
            <div className="NewVersionBanner__ribbon" />
            <div className="NewVersionBanner__content">
              A new version of the ServiceBell dashboard is available. Click the button
              below to reload.
            </div>
            <Button type="primary" onClick={() => window.location.reload()}>
              Click here to Reload
            </Button>
          </div>
        ),
      });
    }
  }, [isNewVersionAvailable]);

  return null;
};
